import * as React from 'react';

export interface ButtonInternalLinkProps {
    children: React.ReactNode;
    onClick: Function;
}

const ButtonInternalLink = ({
    children,
    variant,
    onClick,
    ...restProps
}: ButtonInternalLinkProps & any) => {
    const variantClass = variant ? `rw-reply-${variant}` : '';

    return (
        <button
            type="button"
            className={`rw-reply ${variantClass} rw-button-link-internal`}
            onClick={(e) => {
                e.stopPropagation();
                onClick && onClick(e);
            }}
            onMouseUp={(e) => e.stopPropagation()}
            {...restProps}
        >
            {children}
            <svg
                className="reply-icon filled"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.7833 7.4099L9.68667 3.31323L8.98 4.0199L12.46 7.4999H2V8.4999H12.46L8.98 11.9799L9.68667 12.6866L13.7833 8.5899C14.1067 8.26657 14.1067 7.73657 13.7833 7.4099Z"
                    fill="#1F1F1F"
                />
            </svg>
        </button>
    );
};

export default ButtonInternalLink;
